import axios from 'axios';

const model = 'Habilidad';
const API_URL = process.env.VUE_APP_API_URL;

export default {
  /**
   * @param {{ glosa?: string | null, vigente?: boolean, todos?: boolean }} params
   * - todos: si true, lista vigentes y no vigentes (ignora filtro vigente salvo para búsqueda por glosa).
   */
  listar(params = {}) {
    const query = new URLSearchParams();
    if (params.glosa != null && params.glosa !== '') query.append('glosa', params.glosa);
    if (typeof params.vigente === 'boolean') query.append('vigente', String(params.vigente));
    if (params.todos === true) query.append('todos', 'true');
    const qs = query.toString();
    return axios.get(`${API_URL}/${model}/v1/list${qs ? `?${qs}` : ''}`);
  },

  crear(payload) {
    return axios.post(`${API_URL}/${model}/v1`, payload);
  },

  actualizar(id, payload) {
    return axios.put(`${API_URL}/${model}/v1?id=${id}`, payload);
  },
};
